export default __webpack_public_path__ + "fbf77ce90277c959c3d258f700506750.svg";